/**
 * Author: Claude Code
 * Version: v3.2.38
 * Modified: 2025-10-04
 *
 * AgentPanel - 右侧Agent面板容器（可折叠、半透明风格）支持史莱姆大头照
 */

import React, { useState } from 'react';
import { AgentCard, AgentData } from './AgentCard';

export interface AgentPanelProps {
  agents: AgentData[];
  onBet?: (agentId: number, amount: number) => void;
  userBalance?: number;
  portraits?: { [colorIndex: number]: string }; // Portrait preloaded paths
}

export const AgentPanel: React.FC<AgentPanelProps> = ({
  agents,
  onBet,
  userBalance = 5000,
  portraits
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const aliveCount = agents.filter(a => a.status !== 'died').length;

  return (
    <div className={`agent-panel ${isCollapsed ? 'collapsed' : ''}`}>
      {isCollapsed ? (
        // 收起状态：垂直Tab设计
        <div className="agent-panel-tab" onClick={() => setIsCollapsed(false)}>
          <div className="tab-icon">🤖</div>
          <div className="tab-text">AGENTS</div>
          <div className="tab-badge">{aliveCount}</div>
          <div className="tab-arrow">◀</div>
        </div>
      ) : (
        // 展开状态
        <>
          <div className="agent-panel-header" onClick={() => setIsCollapsed(true)}>
            <h3>🤖 Agents</h3>
            <div className="agent-header-info">
              <span className="agent-count">{aliveCount} alive</span>
              <button className="collapse-btn">▶</button>
            </div>
          </div>

          <div className="agent-panel-body">
            {agents.map((agent) => (
              <AgentCard
                key={agent.id}
                agent={agent}
                onBet={onBet}
                userBalance={userBalance}
                portraits={portraits}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};
